import { palletVixellPlace } from '../../../utils/pallets/pallet-vixell-place'
import { CheckSvg } from '../../svg/check-svg'
import { StopSvg } from '../../svg/stop-svg'
import { Vixell } from '../../../types/typescript-axios'
import { Link } from 'react-router-dom'

type Props = {
  vixells: Array<
    Pick<Vixell, 'id' | 'serialNo' | 'model'> & { inspectionResult?: string }
  >
}
export const VixellPalletVixellList = ({ vixells }: Props) => (
  <div className="grid">
    <div className="grid grid-cols-[auto_1fr_1fr] gap-12">
      <div>TB:</div>
      {vixells
        .filter((v) => palletVixellPlace(v.model) === 'topBottom')
        .map((v) => (
          <div className="grid grid-flow-col gap-2" key={v.id}>
            <Link
              className="text-blue-500"
              to={`/vixells/${v.id}`}
              onClick={(e) => e.stopPropagation()}
            >
              {v.serialNo}
            </Link>
            {(function (result) {
              return !result ? (
                ''
              ) : result === 'Pass' ? (
                <CheckSvg width={20} height={20} />
              ) : (
                <StopSvg width={20} height={20} />
              )
            })(v.inspectionResult)}
          </div>
        ))}
    </div>
    <div className="grid grid-cols-[auto_1fr_1fr] gap-12">
      <div>FB:</div>
      {vixells
        .filter((v) => palletVixellPlace(v.model) === 'frontBack')
        .map((v) => (
          <div className="grid grid-flow-col gap-2" key={v.id}>
            <Link
              className="text-blue-500"
              to={`/vixells/${v.id}`}
              onClick={(e) => e.stopPropagation()}
            >
              {v.serialNo}
            </Link>
            {(function (result) {
              return !result ? (
                ''
              ) : result === 'Pass' ? (
                <CheckSvg width={20} height={20} />
              ) : (
                <StopSvg width={20} height={20} />
              )
            })(v.inspectionResult)}
          </div>
        ))}
    </div>
    <div className="grid grid-cols-[auto_1fr_1fr] gap-12">
      <div>LR:</div>
      {vixells
        .filter((v) => palletVixellPlace(v.model) === 'leftRight')
        .map((v) => (
          <div className="grid grid-flow-col gap-2" key={v.id}>
            <Link
              className="text-blue-500"
              to={`/vixells/${v.id}`}
              onClick={(e) => e.stopPropagation()}
            >
              {v.serialNo}
            </Link>
            {(function (result) {
              return !result ? (
                ''
              ) : result === 'Pass' ? (
                <CheckSvg width={20} height={20} />
              ) : (
                <StopSvg width={20} height={20} />
              )
            })(v.inspectionResult)}
          </div>
        ))}
    </div>
  </div>
)
